import React, { useEffect } from 'react';

const QuestionScreen = ({ 
  currentQuestion, 
  currentQuestionIndex, 
  gameData, 
  score, 
  selectedAnswer, 
  showFeedback, 
  feedback, 
  loading, 
  error, 
  submitAnswer, 
  getAnswerButtonClass 
}) => {
  // Log component lifecycle and state changes
  useEffect(() => {
    console.log('[QuestionScreen] Component mounted/updated', {
      currentQuestionIndex,
      hasQuestion: !!currentQuestion,
      questionText: currentQuestion?.question?.substring(0, 50) + '...',
      answersCount: currentQuestion?.answers?.length,
      score,
      selectedAnswer,
      showFeedback,
      loading,
      hasError: !!error,
      gameData: gameData ? {
        gameId: gameData.gameId,
        questionCount: gameData.questionCount,
        category: gameData.category,
        difficulty: gameData.difficulty
      } : null
    });
  }, [currentQuestion, currentQuestionIndex, gameData, score, selectedAnswer, showFeedback, loading, error]);

  const handleAnswerClick = (answerIndex) => {
    console.log('[QuestionScreen] Answer clicked', {
      answerIndex,
      answerText: currentQuestion?.answers?.[answerIndex],
      questionIndex: currentQuestionIndex,
      selectedAnswer,
      showFeedback
    });
    submitAnswer(answerIndex);
  };
  const categories = [
    { id: 9, name: "General Knowledge" },
    { id: 17, name: "Science & Nature" },
    { id: 18, name: "Science: Computers" },
    { id: 19, name: "Science: Mathematics" },
    { id: 20, name: "Mythology" },
    { id: 21, name: "Sports" },
    { id: 22, name: "Geography" },
    { id: 23, name: "History" },
    { id: 24, name: "Politics" },
    { id: 25, name: "Art" },
    { id: 26, name: "Celebrities" },
    { id: 27, name: "Animals" },
    { id: 28, name: "Vehicles" }
  ];

  return (
    <div className={`question-card ${loading ? 'loading' : ''}`}>
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ 
            width: `${((currentQuestionIndex + 1) / gameData.questionCount) * 100}%`,
            transition: 'width 0.3s ease-in-out'
          }}
        />
      </div>
      
      <div className="question-info">
        <div className="category-badge">
          {categories.find(cat => cat.id === gameData.category)?.name || 'General Knowledge'}
        </div>
        <div className="score-display">
          Question {currentQuestionIndex + 1} of {gameData.questionCount} | Score: {score}
        </div>
        <div className={`difficulty-badge ${gameData.difficulty || 'medium'}`}>
          {(gameData.difficulty || 'medium').toUpperCase()}
        </div>
      </div>
      
      {loading ? (
        <div className="loading">
          <div className="loading-spinner"></div>
          Loading question...
        </div>
      ) : currentQuestion ? (
        <div>
          <div className="question-text">{currentQuestion.question}</div>
          {currentQuestion.answers.map((answer, index) => (
            <button
              key={index}
              className={`answer-button ${getAnswerButtonClass(index)}`}
              onClick={() => handleAnswerClick(index)}
              disabled={selectedAnswer !== null || showFeedback}
            >
              {answer}
            </button>
          ))}
        </div>
      ) : (
        <div className="loading" style={{ 
          opacity: 0.8,
          transition: 'opacity 0.2s ease-in-out'
        }}>No question available</div>
      )}
      
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default QuestionScreen;
